"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// =======
// ACTIONS
// =======
const constants_1 = require("../constants");
// ===============
// ACTION CREATORS
// ===============
// None
// =======
// REDUCER
// =======
const version = (state = {}, action) => {
    switch (action.type) {
        case constants_1.LOAD_NEW_FORMS: {
            return {
                ...state,
                [action.id]: action.version,
            };
        }
        case 'FormModel/LOAD_FORM': {
            return {
                ...state,
                [action.payload.modelKey]: action.payload.version,
            };
        }
        case constants_1.REMOVE_FORM: {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { [action.id]: remove, ...newState } = state;
            return newState;
        }
        default:
            return state;
    }
};
exports.default = version;
//# sourceMappingURL=version.js.map